import React from 'react';
import { Button } from 'reactstrap';

interface PropTypes {
  onCancel: () => void;
  onContinue: () => void;
}

export function ButtonsRow(props: PropTypes) {
  return (
    <div className='d-flex justify-content-end gap-2'>
      <Button color='secondary' onClick={props.onCancel}>
        Cancel
      </Button>
      <Button color='danger' onClick={props.onContinue}>
        Continue
      </Button>
    </div>
  );
}
